goog.provide("shadow.js.shim.module$$mui$icons_material$Refresh$default");
shadow.js.shim.module$$mui$icons_material$Refresh$default = shadow.js.shim.module$$mui$icons_material$Refresh.default;
